// ui
import { ChakraProvider, Box } from "@chakra-ui/react";
import { PodcastNav, Banner, Hero, PodcastProvider, PodcastGrid, PodcastFooter, SmallScreenPodcastModal, PodcastPlaybar } from "components/podcast";
// theme
import { theme } from "./theme";

export function Podcast() {
  return (
    <ChakraProvider theme={theme}>
      <Box className="content" position="relative">
        <PodcastProvider>
          <PodcastNav />
          <PodcastPlaybar />
          <Box minH="80vh">
            <Banner />
            <Hero />
            <PodcastGrid />
            <SmallScreenPodcastModal />
          </Box>
          <PodcastFooter />
        </PodcastProvider>
      </Box>
    </ChakraProvider>
  );
}
